module.exports = __webpack_public_path__ + "img/journey-green-logo.23d98c56.svg";